import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ data, options, height = 300 }) => {
  const chartData = {
    labels: data.labels || [],
    datasets: data.datasets.map(dataset => ({
      label: dataset.label,
      data: dataset.data,
      backgroundColor: dataset.backgroundColor || '#3b82f6',
      borderColor: dataset.borderColor || '#2563eb',
      borderWidth: 1,
      borderRadius: 6,
      borderSkipped: false
    }))
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#374151',
          usePointStyle: true,
          padding: 20
        }
      },
      title: {
        display: options?.plugins?.title?.display || false,
        text: options?.plugins?.title?.text || '',
        color: '#1f2937',
        font: {
          size: 16,
          weight: 'bold'
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#6b7280'
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          color: '#6b7280',
          callback: options?.scales?.y?.ticks?.callback || function(value) {
            return value;
          }
        }
      }
    },
    ...options
  };

  return (
    <div style={{ height: `${height}px` }}>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default BarChart;